e360.controller('EditSurveyItemController',
   ['$scope', '$uibModalInstance', 'surveyItemsApi', 'surveyItem', 'languages', 'language',
      function ($scope, $modalInstance, surveyItemsApi, surveyItem, languages, language) {
         var members = {};

         $scope.language = language;
         $scope.languages = languages;

         members.initialize = function () {
            $scope.busy = false;
            $scope.surveyItemTypes = ['Boolean', 'Text', 'Option', 'Multioption'];
            $scope.mode = (surveyItem.id) ? 'edit' : 'add';
            $scope.surveyItem = angular.copy(surveyItem);
         };

         $scope.isEditing = function () {
            return $scope.mode === 'add' || $scope.mode === 'edit';
         };

         $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
         };

         $scope.save = function () {
            var promise;

            $scope.busy = true;

            switch ($scope.mode) {
               case 'edit':
                  promise = surveyItemsApi.update($scope.surveyItem);
                  break;
               case 'add':
                  promise = surveyItemsApi.create($scope.surveyItem);
                  break;
            }

            promise.then(function () {
               $scope.busy = false;
               $modalInstance.close();
            }, function(err) {
               $scope.busy = false;
            });
         };

         members.initialize();
      }]);